import { render, staticRenderFns } from "./YChooseAreaPro.vue?vue&type=template&id=d60e58f2&scoped=true&"
import script from "./YChooseAreaPro.vue?vue&type=script&lang=js&"
export * from "./YChooseAreaPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60e58f2",
  null
  
)

export default component.exports